module.exports = __webpack_public_path__ + "img/album19_04.bf74368d.jpg";